import React from 'react'
import { Placemark } from 'react-yandex-maps'

export default function DevelopersMapPlacemark ({ coordinates = [], content = '', icon = null }) {
  const iconStyle = icon ? {
    iconLayout: 'default#image',
    iconImageHref: decodeURIComponent(icon),
    iconImageSize: [64, 64],
    iconImageOffset: [-30, -68]
  } : null

  return <Placemark
    geometry={ coordinates }
    properties={ {
      balloonContent: content
    } }
    options={{
      ...iconStyle
    }}
  />
}